import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb as BC } from "antd";
import { Template } from "../../redux/interfaces/templates.types.ts";
import { Link } from "react-router-dom";

interface Props {
  template: Template;
}

export const BreadcrumbComponent: React.FC<Props> = ({ template }) => {
  return (
    <BC
      items={[
        {
          title: (
            <Link to="/">
              <HomeOutlined />
            </Link>
          ),
        },
        {
          title: (
            <Link to="/templates">
              <span>Plantillas</span>
            </Link>
          ),
        },
        {
          title: `${template.name}`,
        },
      ]}
    />
  );
};
